import { Flex, Tag, Typography } from "antd"

import styles from "./panel.module.less"

const { Text } = Typography

// A row of a card's panels under its KPIs (DAA-1-21, DAA-1-22): twelve columns, so a panel's edge
// can line up with a KPI divider — beside three KPIs, panels of 8 and 4 meet under the second one.
// Below 700 px the panels stack (DAA-1-15).
export const PanelRow = ({ children }) => <div className={styles.row}>{children}</div>

// A panel's title with its corner tag, a neutral platform tag at its right end ("per day",
// "weekly", "stacked · per day"; DAA-2-23). A head without a tag keeps a tag's 22px, so panels side
// by side start their content on one line.
export const PanelHead = ({ title, tag }) => (
  <Flex
    align="center"
    justify="space-between"
    gap={12}
    wrap="wrap"
    style={{ marginBottom: 16, minHeight: 22 }}
  >
    <Text strong>{title}</Text>
    {tag && <Tag className={styles.tag}>{tag}</Tag>}
  </Flex>
)

// One panel: its head, then its chart or table. `span` is out of 12.
export const Panel = ({ title, tag, span = 12, children }) => (
  <section className={styles.panel} style={{ "--span": span }}>
    <PanelHead title={title} tag={tag} />
    {children}
  </section>
)
